import React from 'react'
import { Carousel, ArrowButton } from 'pcln-carousel'
import FlexDatesCard from '../FlexDatesCard'
import { IFlexDatesCarousel } from './FlexDatesCarouselInterface'
import { noop } from 'lodash'

/** @public */
const FlexDatesCarousel: React.FC<IFlexDatesCarousel> = ({
  flexDates,
  onSlideClick,
  visibleSlides,
  onSlideChange,
}: IFlexDatesCarousel) => {
  /* istanbul ignore next */
  function onSlideKeyDown(index, e) {
    if (e.keyCode === 13 || e.key === 'Enter' || e.keyCode === 32 || e.key === ' ') {
      onSlideClick(index, e)
    }
  }

  return (
    <Carousel
      stretchSlideHeight={false}
      visibleSlides={visibleSlides}
      slideSpacing={1}
      sideButtonMargin='0px'
      sidePositionArrowButton={<ArrowButton buttonSize='32px' mt='-16px !important' />}
      onSlideClick={onSlideClick}
      onSlideKeyDown={onSlideKeyDown}
      onSlideChange={onSlideChange}
    >
      {flexDates.map((date) => {
        const {
          isOriginalDepartDate,
          formatDepartDateUrl,
          flexDate,
          priceText,
          stopsText,
          priceHighlightColor,
          description,
          descriptionColor,
        } = date
        return (
          <FlexDatesCard
            key={formatDepartDateUrl}
            date={flexDate}
            priceText={priceText}
            stopsText={stopsText}
            priceHighlightColor={priceHighlightColor}
            isSelected={isOriginalDepartDate}
            description={description}
            descriptionColor={descriptionColor}
          />
        )
      })}
    </Carousel>
  )
}

FlexDatesCarousel.defaultProps = {
  visibleSlides: [2.5, 3.5, 4.1],
  onSlideChange: noop,
}

export { FlexDatesCarousel }
